import React, { useState } from "react";
import { Box, Card, CardContent, Chip, Divider, Grid2, IconButton, Tooltip, Typography, useTheme } from "@mui/material";
import { useNavigate, useNavigationType, useParams } from "react-router-dom";
import moment from "moment";
import { IoMdArrowRoundBack } from "react-icons/io";
import HistoryTimeLine from "components/HistoryTimeLine";
import { dispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useGetMilestoneDetailQuery } from "store/slices/apis/milestonePackageSlice";
import MilestoneComment from "./MilestoneComment";
import { usePermission } from "hooks/usePermission";
import { MILESTONE_APPROVAL } from "config";
import { ReactComponent as LeftArrowicon } from "assets/PwC_Funct_Icons_ArrowLeft_Outline_Black_RGB.svg"

const grids = [
    {
        name: 'Workflow name',
        field: 'workflowName',
        renderer(params) {
            return (
                <Chip size="small" sx={{
                    fontSize: '12px',
                    '& .MuiChip-label': {
                        paddingLeft: '8px',
                        paddingRight: '8px',
                        fontWeight: 600
                    }
                }} label={`${params ?? 'N/A'}`} />
            )
        }
    },
    {
        name: 'Milestone Name',
        field: 'milestone_name',
    },
    {
        name: 'Plan finish date',
        field: "plan_date",
        renderer(params) {
            return (
                <>
                    {params
                        ? moment(params).format("DD/MM/YY")
                        : "N/A"}
                </>
            );
        },
    },
    {
        name: 'Actual finish date',
        field: "actual_date",
        renderer(params) {
            return (
                <>
                    {params
                        ? moment(params).format("DD/MM/YY")
                        : "N/A"}
                </>
            );
        },
    },
    {
        name: 'Created date',
        field: "createddate",
        renderer(params) {
            return (
                <>
                    {params
                        ? moment(params).format("DD/MM/YY")
                        : "N/A"}
                </>
            );
        },
    },
]


const MilestoneDetail = () => {

    const theme = useTheme();
    const navigate = useNavigate();
    const navigationType = useNavigationType();

    const { id, assignee, isEditable } = useParams();

    const decrypt = (encoded) => decodeURIComponent(escape(atob(encoded)));
    const decrypted = decrypt(assignee);

    const riskDetailRes = useGetMilestoneDetailQuery(id);
    const canApprove = usePermission(MILESTONE_APPROVAL);

    const [isEditKeyRiskModal, setEditKeyRiskModal] = useState(false);
    const [workflowStatus, setWorkflowStatus] = useState('N/A');
    const [rowData, setRowData] = useState(false);

    const handleActionEdit = (row) => {
        setEditKeyRiskModal((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    const openNotification = async (msg, type = 'error') => {
        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), 3000);
    };

    return (
        <>
            <Grid2 container spacing={2} sx={{ mt: '20px' }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="h5" sx={{ fontSize: '24px', fontWeight: '500', color: '#252525', mb: 2, lineHeight: "32px", letterSpacing: '-0.4px' }}>
                        <Tooltip
                            placement="bottom"
                            title="Back"
                            arrow
                            slotProps={{
                                tooltip: { sx: { fontSize: "12px" } },
                            }}
                        >
                            {window.history.length > 1 && navigationType !== "POP" &&
                                <IconButton
                                    aria-label="download"
                                    size="small"
                                    onClick={() => {
                                        navigate(-1)
                                    }}
                                >
                                    <LeftArrowicon style={{ height: '22px', width: '22px', color: "#252525", stroke: "#252525", strokeWidth: 4 }} />
                                </IconButton>
                            }
                        </Tooltip>

                        Milestone Detail
                    </Typography>
                </Box>
            </Grid2>
            <Grid2 container spacing={2} sx={{ mt: '20px' }}>
                <Grid2 size={12}>
                    <Card sx={{ borderRadius: 1, boxShadow: 'none', p: 3, pt: 1.5 }}>
                        <Box sx={{ width: '100%', mb: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontSize: '20px',
                                    fontWeight: '500',
                                    color: '#252525',
                                    lineHeight: '32px',
                                    letterSpacing: '-0.4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                }}
                            >
                                {`Milestone ID`}
                                <Chip
                                    label={`${riskDetailRes?.data?.data?.milestone_number}`}
                                    size="small"
                                    sx={{
                                        height: '20px',
                                        color: '#fff',
                                        fontSize: '12px',
                                        backgroundColor: `${theme?.customSettings?.themeColor}`,
                                    }}
                                />
                            </Typography>
                            {/* {riskDetailRes?.data?.data?.currentStatus != 'Close' && isEditable == 'true' && */}
                            {/* <Tooltip
                                placement="top"
                                title={"Edit"}
                                arrow
                                slotProps={{
                                    tooltip: { sx: { fontSize: "12px" } },
                                }}
                            >
                                <IconButton
                                    aria-label="Edit Issue"
                                    size="small"
                                    onClick={() => handleActionEdit(riskDetailRes?.data?.data)}
                                >
                                    <FaRegEdit />
                                </IconButton>
                            </Tooltip> */}
                            {/* } */}

                        </Box>
                        <Divider sx={{ mb: 2 }} />
                        <CardContent sx={{ p: 0 }}>
                            <Grid2 container spacing={2}>
                                <Grid2 size={{ xs: 12, md: 3, sm: 4 }}>
                                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>Workflow status</Typography>
                                    <Chip size="small" sx={{
                                        fontSize: '12px',
                                        '& .MuiChip-label': {
                                            paddingLeft: '8px',
                                            paddingRight: '8px',
                                            fontWeight: 600
                                        }
                                    }} label={`${workflowStatus}`} />
                                </Grid2>

                                {grids?.map((val, index) => {
                                    return (
                                        <Grid2 size={{ xs: 12, md: 3, sm: 4 }}>
                                            <Typography variant="body1" sx={{ color: 'text.secondary' }}>{val?.name}</Typography>
                                            {val?.renderer ?
                                                val.renderer(riskDetailRes?.data?.data[val?.field])
                                                :
                                                <Typography gutterBottom variant="body2">{riskDetailRes?.data?.data[val?.field]}</Typography>
                                            }
                                        </Grid2>
                                    )
                                })}
                            </Grid2>
                        </CardContent>
                    </Card>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <HistoryTimeLine id={id} workflow={setWorkflowStatus} />
                </Grid2>
                {canApprove && decrypted == 'edit' &&
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <Card sx={{ borderRadius: 1, boxShadow: 'none', p: 3, pt: 1.5, minHeight: '250px' }}>
                            <Box sx={{ width: '100%', mb: 1.5 }}>
                                <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: '500', color: '#252525', lineHeight: "32px", letterSpacing: '-0.4px' }}>
                                    Add comment
                                </Typography>
                            </Box>
                            <Divider sx={{ mb: 2 }} />
                            <CardContent sx={{ p: 0 }}>
                                <MilestoneComment id={id} rowData={riskDetailRes?.data?.data} />
                            </CardContent>
                        </Card>
                    </Grid2>
                }

            </Grid2>

        </>
    );
}

export default MilestoneDetail;
